import React, {Suspense} from 'react';
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {
    ReportDailyExecutionSingleVoyageLazy
} from "@containers/singleVoyage/reports/reportDailyExecution/ReportDailyExecutionSingleVoyage.lazy";


const ReportDailyExecutionSingleVoyagePage = () => {
    return (
        <PageLayout>
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <ReportDailyExecutionSingleVoyageLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default ReportDailyExecutionSingleVoyagePage;
